// extracted by mini-css-extract-plugin
export default {"containerSearch":"searchCafeterias_containerSearch__gKXzL","containerInput":"searchCafeterias_containerInput__iHerW"};